import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endpoints from "../../../api/endpoints";
import axiosInstance from "../../../api/axiosInstance";

interface SpecialArticleState {
  data: ScenarioData | null;
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
}

export interface Variable {
  LineNumber: string;
  VarValues: string[];
  VarConditions: string;
  ABQNUM: string;
  ABQVAL: string;
  SYMDES: string;
  SYMNUM: string;
  // manque d'autres propriétés selon la définition réelle de Variable
}

export interface Question {
  LineNumber: string;
  TypeReponse: string | null;
  QuestionCode: string;
  QuestionContent: string;
  MINVALUE?: number;
  MAXVALUE?: number;
  DataValues?: {
    Name: string;
    Val: string;
    NumLigne: string;
    isActif: boolean;
  }[];
  QuestionCondition?: string;
  TABLECODE?: string;
  val?: string | null;
  isActif: boolean | null;
  finalConditionQ?: string;
  QuestionDropDownFilter?: string;

  // Ajout des nouvelles propriétés :
  ProcedureList?: ProcedureSage[];
  ProcedureNamesList?: string[];
  YFILPRO?: string;
}

export interface ProcedureSage {
  ListeVariablesProcedure: Variable[];
  ProcedureName: string;
}




export interface ScenarioData {
  Questions?: Question[];
  Variables?: Variable[];
}

const initialState: SpecialArticleState = {
  data: null,
  status: "idle",
  error: null,
};

export const fetchQuestionsByScenario = createAsyncThunk(
  "articles/fetchQuestionsByScenario",
  async (scenario: string, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        endpoints.articles.getScenario + scenario
      );

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(error.response?.data || "Erreur réseau");
      }
      return rejectWithValue("Une erreur inconnue est survenue");
    }
  }
);


export const fetchUpdatedData = createAsyncThunk(
  "articles/fetchUpdatedData",
  async (
    payload: { questions: Question[]; variables: Variable[] },
    { rejectWithValue }
  ) => {
    try {
      const response = await axiosInstance.post(
        endpoints.articles.updateData,
        payload
      );

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(error.response?.data || "Erreur réseau");
      }
      return rejectWithValue("Une erreur inconnue est survenue");
    }
  }
);

const specialArticleSlice = createSlice({
  name: "specialArticle",
  initialState,
  reducers: {
    resetError(state) {
      state.error = null;
    },
    resetState() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchQuestionsByScenario.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchQuestionsByScenario.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(fetchQuestionsByScenario.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string;
      })
      .addCase(fetchUpdatedData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchUpdatedData.fulfilled, (state, action) => {
        state.status = "succeeded";
        if (state.data?.Questions) {
          state.data.Questions =
            action.payload.Questions ?? action.payload.questions ?? [];
        }
      })
      .addCase(fetchUpdatedData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string;
      });
  },
});

export const { resetError, resetState } = specialArticleSlice.actions;

export default specialArticleSlice.reducer;
